module.exports = __webpack_public_path__ + "static/media/Documents.bf92e13f.svg";